import { createSelector } from 'reselect';
 
const selectOneServiceProvider = (state: any) => state.oneServiceProvider;


export const selectOneServiceProviderCurrentItem = createSelector([selectOneServiceProvider], (oneServiceProvider) => oneServiceProvider.current);

export const selectOneServiceProviderListItems = createSelector([selectOneServiceProvider], (oneServiceProvider) => oneServiceProvider.list);

export const selectOneServiceProviderQueryItems = createSelector([selectOneServiceProvider], (oneServiceProvider) => oneServiceProvider.query);
export const selectOneServiceProviderItemById = (itemId: any) =>
    createSelector(selectOneServiceProviderListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOneServiceProviderCreatedItem = createSelector([selectOneServiceProvider], (oneServiceProvider) => oneServiceProvider.create);

export const selectOneServiceProviderUpdatedItem = createSelector([selectOneServiceProvider], (oneServiceProvider) => oneServiceProvider.update);

export const selectOneServiceProviderReadItem = createSelector([selectOneServiceProvider], (oneServiceProvider) => oneServiceProvider.read);

export const selectOneServiceProviderDeletedItem = createSelector([selectOneServiceProvider], (oneServiceProvider) => oneServiceProvider.delete);

export const selectOneServiceProviderSearchedItems = createSelector([selectOneServiceProvider], (oneServiceProvider) => oneServiceProvider.search);

export const selectOneServiceProviderItemsCount = createSelector([selectOneServiceProvider], (oneServiceProvider) => oneServiceProvider.count);

export const selectOneServiceProviderItemsFilter = createSelector([selectOneServiceProvider], (oneServiceProvider) => oneServiceProvider.filter);